
import { Component, Vue } from "vue-property-decorator";
import tigermaster from "fdtigermaster-client-sdk";

import Navbar from "@/components/Utility/Navbar.vue";
// import NavbarWithAcademyDropdown from '@/components/Utility/NavbarWithAcademyDropdown.vue'
import Footer from "@/components/Utility/Footer.vue";

@Component({
  components: {
    Navbar,
    // NavbarWithAcademyDropdown,
    Footer,
  }
})
export default class App extends Vue {
  appStatus: "loading" | "ready" | "error" = "loading";

  get isStandalonePage(): boolean {
    return Boolean(this.$route.meta && this.$route.meta.standalone);
  }

  created(): void {
    this.initializeApp();
  }

  async initializeApp(): Promise<void> {
    this.appStatus = "loading";

    try {
      await tigermaster.initializeApp({
        stage: process.env.VUE_APP_BACKEND_URL,
      });
      this.appStatus = "ready";
    } catch (error) {
      console.error("Failed to initialize the application.", error);
      this.appStatus = "error";
    }
  }
}
